export const getLocalStorageItem = (key: string) => {
  try {
    const item = localStorage.getItem(key);
    // Handle null, undefined, or the string "undefined"
    if (item === null || item === undefined || item === 'undefined') {
      return null;
    }
    return JSON.parse(item);
  } catch (error) {
    console.error(`Failed to parse localStorage item "${key}":`, error);
    return null;
  }
};

export const setLocalStorageItem = (key: string, value: unknown) =>
  localStorage.setItem(key, JSON.stringify(value));

const DEVICE_SETTINGS_PREFIX = 'ds:';

export function getDeviceSetting(name: string): string | null {
  return localStorage.getItem(DEVICE_SETTINGS_PREFIX + name);
}

export function setDeviceSetting(name: string, value: string) {
  localStorage.setItem(DEVICE_SETTINGS_PREFIX + name, value);
}

export function removeDeviceSetting(name: string) {
  localStorage.removeItem(DEVICE_SETTINGS_PREFIX + name);
}

export const DeviceSettingsStorage = {
  getItem(key: string): string | null {
    return getDeviceSetting(key);
  },
  setItem(key: string, value: string): void {
    setDeviceSetting(key, value);
  },
  removeItem(key: string): void {
    removeDeviceSetting(key);
  },
};

export function clearLocalStorage() {
  const deviceKeys = Array.from({ length: localStorage.length }, (_, index) =>
    localStorage.key(index)
  ).filter(
    (key): key is string =>
      key !== null && key.startsWith(DEVICE_SETTINGS_PREFIX)
  );

  const preserved = deviceKeys
    .map((key): [string, string | null] => [key, localStorage.getItem(key)])
    .filter((entry): entry is [string, string] => entry[1] !== null);

  // eslint-disable-next-line no-restricted-properties
  localStorage.clear();
  for (const [key, value] of preserved) {
    localStorage.setItem(key, value);
  }
}

const LAST_LOGIN_EMAIL_COOKIE = 'littlebird_last_login_email';

export function setLastLoginEmail(email: string): void {
  DeviceSettingsStorage.setItem(LAST_LOGIN_EMAIL_COOKIE, email);
}

export function getLastLoginEmail(): string | null {
  const value = DeviceSettingsStorage.getItem(LAST_LOGIN_EMAIL_COOKIE);
  // The v0.73.21 migration to ds: keys copied some values JSON-quoted, as '"a@b.com"'
  if (value?.startsWith('"')) {
    try {
      const parsed: unknown = JSON.parse(value);
      if (typeof parsed === 'string') return parsed;
    } catch {
      // Not JSON: the value is the email
    }
  }
  return value;
}

export function getRedirectParamsFromCookie(): Record<string, string> {
  try {
    const match = document.cookie.match(
      new RegExp('(^| )littlebird_redirect_params=([^;]+)')
    );
    if (!match) return {};
    return JSON.parse(decodeURIComponent(match[2]));
  } catch {
    return {};
  }
}
